import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    OnDestroy,
    OnInit
} from '@angular/core';
import { ReportService } from '../../../services/reportService';
import { RNSStatusReportResponse } from '../../../objects/report/RNSStatusReportResponse';
import { PaginationInstance } from 'ngx-pagination';
import { RNSStatus } from '../../../objects/pars-status-widget/RNS-status';
import { Column } from '../../../objects/users/user';
import { RNSStatusReportRequest } from '../../../objects/requests/RNSStatusReportRequest';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ActivatedRoute } from '@angular/router';
import { ToastsManager } from 'ng2-toastr';

export class DateRangeModel {
    public from: Date;
    public to: Date;

    public constructor(obj? : Partial<DateRangeModel>){
        Object.assign(this,obj);
    }
}

@Component({
    selector: 'rns-status',
    templateUrl: "rns-status.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    moduleId: module.id.toString()
})

export class RnsStatusComponent implements OnInit, OnDestroy, AfterViewInit {

    public orders$: BehaviorSubject<RNSStatusReportResponse[]> = new BehaviorSubject<RNSStatusReportResponse[]>([]);
    public selectedRnsStatus$: BehaviorSubject<RNSStatus> = new BehaviorSubject<RNSStatus>(null);
    public selectedDateRange$: BehaviorSubject<DateRangeModel>;
    public RNSStatus = RNSStatus;
    public isLoading: boolean = false;

    public config: PaginationInstance =  {
        id: 'custom-rns-status-report',
        itemsPerPage: 20,
        currentPage: 1,
        totalItems: 0
    };

    public tableColumns: Column[] = [
        new Column({Index: 1, Name: 'Date', Property : 'Date', IsSelected: true}),
        new Column({Index: 2, Name: 'CCN', Property : 'CCN', IsSelected: true}),
        new Column({Index: 3, Name: 'Transaction Number', Property : 'TransactionNumber', IsSelected: true}),
    ];
    readonly headerHeight = 60;
    readonly rowHeight = 50;

    constructor(private reportService: ReportService,
                private el: ElementRef,
                private route: ActivatedRoute,
                private cdr: ChangeDetectorRef,
                private toast: ToastsManager) {
    }

    public ngOnInit(): void {
        const currentDate = new Date();
        currentDate.setHours(0);
        currentDate.setMinutes(0);
        currentDate.setSeconds(0);
        const previousMonthDate = new Date();
        previousMonthDate.setHours(0);
        previousMonthDate.setMinutes(0);
        previousMonthDate.setSeconds(0);
        previousMonthDate.setDate(currentDate.getDate() - 7);

        this.selectedDateRange$ = new BehaviorSubject<DateRangeModel>(new DateRangeModel({
            from: previousMonthDate,
            to: currentDate
        }));
    }

    private getReportRequest(): RNSStatusReportRequest {
        return new RNSStatusReportRequest({
            From: this.selectedDateRange$.value.from,
            To: this.selectedDateRange$.value.to,
            Status: this.selectedRnsStatus$.value,
            Top: this.config.itemsPerPage,
            Skip: (this.config.currentPage - 1) * this.config.itemsPerPage
        });
    }

    public ngAfterViewInit(): void {
      const timeoutId = setTimeout(() => {
           this.cdr.detectChanges();
           clearTimeout(timeoutId);
       }, 100)
    }

    public ngOnDestroy(): void {
    }

    private loadData(): void {
        this.isLoading = true;
        this.reportService.getRNSStatusReport(this.getReportRequest())
        .then((d) => {
            this.isLoading = false;
            this.config.totalItems = d.Data.TotalCount;
            this.orders$.next(d.Data.Items);
        }, () => {
            this.isLoading = false;
        });
    }

    public handleDayChanging(date: Object): void {
        this.selectedDateRange$.next(new DateRangeModel({
            from: date['beginJsDate'],
            to: date['endJsDate']
        }));
    }

    public downloadFile(): void {
        if (!this.selectedRnsStatus$.value) {
            this.toast.error('Please select RNS Status');
            return;
        }

        this.isLoading = true;
        const request = this.getReportRequest();
        request.Top = null;

        this.reportService.downloadRNSStatusReport(request).then(() => {
            this.isLoading = false;
        }, () => {
            this.isLoading = false;
        });
    }

    public search(): void {
         this.loadData();
    }

    public apply(): void {
        if (!this.selectedRnsStatus$.value) {
            this.toast.error('Please select RNS Status');
            return;
        }

        this.loadData();
    }
}



// WEBPACK FOOTER //
// ./app/components/reports/rnsStatus/rns-status.component.ts